import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import PublicCampaign from "@/pages/PublicCampaign";
import DonatePage from "@/pages/DonatePage";
import DonateMonthlyPage from "@/pages/DonateMonthlyPage";
import DonationSuccess from "@/pages/DonationSuccess";
import ThankYouPage from "@/pages/ThankYouPage";
import DocumentsPage from "@/pages/DocumentsPage";
import DownloadReceipts from "@/pages/DownloadReceipts";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";
import AdminDonors from "@/pages/admin/AdminDonors";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSlider from "@/pages/admin/AdminSlider";
import AdminWebsite from "@/pages/admin/AdminWebsite";
import AdminSettings from "@/pages/admin/AdminSettings";
import { api } from "@/lib/api";
import { loadMetaPixel } from "@/lib/payments";

function RequireAuth({ children }) {
  const token = localStorage.getItem("seva_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function RootRedirect() {
  const nav = useNavigate();
  useEffect(() => {
    api.get("/campaigns").then((r) => {
      const list = r.data || [];
      if (list.length) nav(`/campaigns/${list[0].slug}`, { replace: true });
      else nav("/no-campaign", { replace: true });
    }).catch(() => nav("/no-campaign", { replace: true }));
  }, [nav]);
  return <div className="min-h-screen bg-[#FBF9F6]" />;
}

function NoCampaign() {
  return (
    <div className="min-h-screen grid place-items-center p-6 text-center">
      <div>
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="SEVA" className="h-20 w-20 object-contain mx-auto mb-4" />
        <h1 className="font-display font-bold text-3xl">No active campaign</h1>
        <p className="text-[#56624F] mt-2">Please check back soon, or ask the admin to publish a campaign.</p>
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    api.get("/settings/public").then((r) => {
      if (r.data?.meta_pixel_id) loadMetaPixel(r.data.meta_pixel_id);
    }).catch(() => {});
  }, []);

  return (
    <div className="App font-body text-[#1F2A1C] bg-[#FBF9F6] min-h-screen">
      <Toaster position="top-center" richColors />
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/no-campaign" element={<NoCampaign />} />
          <Route path="/campaigns/:slug" element={<PublicCampaign />} />
          <Route path="/donation/campaigns/:slug" element={<PublicCampaign />} />
          <Route path="/donate/:slug" element={<DonatePage />} />
          <Route path="/donate-monthly" element={<DonateMonthlyPage />} />
          <Route path="/donation/success" element={<DonationSuccess />} />
          <Route path="/donation/success/:id" element={<DonationSuccess />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/receipts" element={<DownloadReceipts />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="campaigns" element={<AdminCampaigns />} />
            <Route path="donors" element={<AdminDonors />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="slider" element={<AdminSlider />} />
            <Route path="website" element={<AdminWebsite />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
